import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useFormContext } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

import { RejectModal } from './RejectModal'

interface Props {
  showApproveOptions: boolean
  approving: boolean
  rejecting: boolean
  onApprove: () => void
  onReject: (reason: string) => void
  setIsUpdating: (value: boolean) => void
  manageEmployee: boolean
}

export const FooterReview = ({
  showApproveOptions,
  approving,
  rejecting,
  onApprove,
  onReject,
  setIsUpdating,
  manageEmployee,
}: Props) => {
  const form = useFormContext<UpdateData>()

  const [showRejectModal, setShowRejectModal] = useState<boolean>(false)

  return (
    <Box
      maxHeight="s80"
      width="full"
      justifyContent="spaceBetween"
      paddingX="s48"
      paddingY="s24"
      background="white"
      border={{ top: { color: 'grey400', style: 'solid', width: 's1' } }}
      position="sticky"
      style={{ bottom: '0' }}
      flexDirection="row"
    >
      <Box>
        {manageEmployee && (
          <Button
            type="secondary"
            onClick={() => {
              track(trackingEvents.training.trainingRequest.saveTrainingRequest, {
                has_updating: form.dirty,
              })
              setIsUpdating(true)
              form.handleSubmit()
            }}
            disabled={!form.isValid}
          >
            {i18n.t('trainings.training_requests.my_requests.detail.save')}
          </Button>
        )}
      </Box>
      <Box flexDirection="row" gap="s8">
        {showApproveOptions && (
          <>
            {showRejectModal && (
              <RejectModal
                rejecting={rejecting}
                setShowRejectedModal={setShowRejectModal}
                onReject={onReject}
              />
            )}
            <Button
              onClick={() => {
                setShowRejectModal(true)
                track(trackingEvents.training.trainingRequest.rejectTrainingRequest.start)
              }}
            >
              {i18n.t('ats.jobs_requisitions.requisition_detail.reject_request')}
            </Button>
            <Button type="positive" onClick={onApprove} disabled={approving}>
              {i18n.t('ats.jobs_requisitions.requisition_detail.approve_request')}
            </Button>
          </>
        )}
      </Box>
    </Box>
  )
}
